import gql from 'graphql-tag';

export const GET_SYSTEM_MASTER = gql`
  query(
    $settingGroup: String
    $settingKey: String
    $settingValue: Int
  ) {
    GetSystemMaster(
      settingGroup: $settingGroup
      settingKey: $settingKey
      settingValue: $settingValue
    ) {
      SystemMasterLists{
        setting_group
        setting_key
        setting_value
        setting_group_name
        setting_name
        setting_code
        setting_type
        setting_unit
        priority
      }
    }
  }
`;

// システム設定マスタ
export const GET_SETTING_GROUP_LIST = gql`
  query(
    $settingType: Int
  ) {
    GetSettingGroupList(
      settingType: $settingType
    ) {
      SettingGroupLists{
          setting_group
          setting_group_name
      }
    }
  }
`;

export const REGIST_SYSTEM_MASTER = gql`
  mutation (
      $id:   ID
      $name: String!
      $ip:   String!
    ) {
      RegistSystemMaster(
        id: $id
        name: $name
        ip: $ip
      ) {
        result
    }
  }
`;

export const DELETE_SYSTEM_MASTER = gql`
  mutation (
      $id: ID!
    ) {
      DeleteSystemMaster(
        id: $id
      ){
        result
      }
    }
`;

export const UPDATE_SYSTEM_MASTER = gql`
    mutation(
        $UpdateSystemMasterList: [UpdateSystemMasterList]
    ){
        UpdateSystemMaster(
            UpdateSystemMasterList: $UpdateSystemMasterList
        ){
            result
            error_message
        }
    }
`;
